<script>
import SessionContainer from '@/modules/games-shared/SessionContainer';
import config from './config';

export default {
    extends: SessionContainer,
    config
};
</script>
